module.exports = __webpack_public_path__ + "media/ru_ru_s3_Sergey.96ecbab2.oga";